import { useState, useRef, forwardRef, ForwardedRef, ReactNode } from 'react'
import { TokenDefaultIcon } from '@/components/icons/token-default'

export interface TokenLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  srcs: string[]
  fallback?: ReactNode
}

const TokenLogo = forwardRef(
  ({ srcs, alt, fallback, ...rest }: TokenLogoProps, ref: ForwardedRef<HTMLImageElement>) => {
    const [, refresh] = useState<number>(0)
    // Using useRef instead of a global object to track bad sources
    const badSrcsRef = useRef<{ [imageSrc: string]: boolean }>({})

    const src: string | undefined = srcs.find((s) => !badSrcsRef.current[s])

    if (src) {
      return (
        <img
          {...rest}
          ref={ref}
          alt={alt}
          src={src}
          onError={() => {
            if (src) badSrcsRef.current[src] = true
            refresh((i) => i + 1)
          }}
        />
      )
    }

    return fallback || <TokenDefaultIcon className={'size-8 rounded-full border border-primary/60'} />
  },
)

TokenLogo.displayName = 'TokenLogo'

export default TokenLogo
